import { render, staticRenderFns } from "./TransferModal.vue?vue&type=template&id=c8e90c78"
import script from "./TransferModal.vue?vue&type=script&lang=js"
export * from "./TransferModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports